import React, { useEffect, useState } from 'react';

import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';

// Import Components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

//@material-ui/core
import { MenuItem, Select, TextField } from '@material-ui/core';
import Dashboard from '@material-ui/icons/Dashboard';
import { Save, Visibility } from '@material-ui/icons';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import CollapseData from '../CollapseResponse/CollapseData';
import { Link } from 'react-router-dom';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    color: 'black',
    fontWeight: 'bold'
  },
  table: {
    width: '100%',
    minWidth: 1000,
    '& td': {
      borderTop: '1px solid #e7e7e7',
      color: 'black',
      fontWeight: '400'
    }
  }
});

const columnsDetail = [
  { Header: '#', accessor: 'num', width: 80 },
  { Header: 'Tipo', accessor: 'type', width: 100 },
  { Header: 'Cod. Prod.', accessor: 'ItemCode', width: 100, align: 'center' },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: '#Promo', accessor: 'prom_promotion_id', width: 100 },
  { Header: 'Promoción', accessor: 'prom_promotion_description' },
  { Header: 'Regla', accessor: 'prom_rule_description' },
  { Header: "Paq.'s", accessor: 'packs', width: 100, align: 'center' },
  { Header: "Unid.'s", accessor: 'unities', width: 100, align: 'center' },
  { Header: 'Despachado', accessor: 'desp', width: 120, align: 'center' },
  { Header: 'Devuelto', accessor: 'return', width: 100, align: 'center' },
  { Header: 'Diferencia', accessor: 'diference', width: 100, align: 'center' },
  { Header: 'Total', accessor: 'total', width: 100, align: 'right' },
  { Header: 'Estado', accessor: 'state', width: 130 },
  { Header: '', accessor: 'actions', width: 0 }
];

export default WithApp(function ConsolidatedModal(props) {
  const classes = useStyles();

  const {
    open,
    saveDocument,
    changeValueDocDetail,
    selectedDoc,
    listStatesDoc,
    stateHR,
    closeModal,
    setShowEye,
    setListDoc,
    listDoc,
    responsible = 'N',
  } = props;

  const [listDocDetail, setListDocDetail] = useState([]);
  const [showErrorResp, setShowErrorResp] = useState({ show: false });

  const [actualStateDoc, setActualStateDoc] = useState();
  const [stateDoc, setStateDoc] = useState();
  const [totals, setTotals] = useState({});

  const handleClose = () => {
    closeModal(false);
    setShowEye(false);
    setListDoc([...listDoc]);
    setShowErrorResp({ show: false });
  };

  function calcTotals(listDocDetail) {
    let completed = 0;
    let anulated = 0;
    let partial = 0;

    for (let obj of listDocDetail) {
      if (obj.liq_status == '0') {
        completed += parseFloat(obj.GTotal);
      } else if (obj.liq_status == '1') {
        anulated += parseFloat(obj.GTotal);
      } else if (obj.liq_status == '2') {
        partial += parseFloat(obj.GTotal);
      }
    }
    setTotals({
      completed: completed.toFixed(2),
      anulated: anulated.toFixed(2),
      partial: partial.toFixed(2)
    });
  }

  useEffect(() => {
    if (open) {
      setListDocDetail(props.listDocDetail);
      calcTotals(props.listDocDetail);
    }
  }, [props.listDocDetail]);

  useEffect(() => {
    setStateDoc(props.stateDoc);
  }, [props.stateDoc]);

  useEffect(() => {}, [props.stateHR]);

  /* useEffect(() => {
    setActualStateDoc(props.actualStateDoc);
  }, [props.actualStateDoc]); */

  return (
    <ModalFull open={open} setOpen={handleClose} title="Detalle de Documento">
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Dashboard />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Detalle de Documento</h4>
        </CardHeader>
        <CardBody>
          <HeaderModal selectedDoc={selectedDoc} totals={totals} />

          {showErrorResp.show ? (
            <CollapseData
              title="Mostrar productos a retirar de liquidación"
              close={() => setShowErrorResp({ show: false })}
            >
              <ErrorResponse data={showErrorResp.data} />
            </CollapseData>
          ) : undefined}

          <ReactTable
            exportExcel={false}
            defaultWidth={1400}
            colorRow={(item) => {
              return item.type == 'Bonificación' ? '#43ff6b61' : '';
            }}
            columns={columnsDetail}
            data={listDocDetail.map((doc, i) => {
              return {
                num: i + 1,
                type: doc.type === 'B' ? 'Bonificación' : 'Normal',
                ItemCode: doc.ItemCode,
                ItemName: doc.ItemName,
                prom_promotion_id: doc.prom_promotion_id ? (
                  <div className="actions-right">
                    {doc.prom_promotion_id}
                    <Button justIcon round simple color="primary">
                      <Link
                        target="_blank"
                        to={`/admin/articulos/operaciones/promociones/${doc.prom_promotion_id}`}
                      >
                        <Visibility />
                      </Link>
                    </Button>
                  </div>
                ) : undefined,
                prom_promotion_description: doc.prom_promotion_description,
                prom_rule_description:
                  doc.type === 'B'
                    ? `${doc.prom_rule_id || ''} - ${doc.prom_rule_description || ''}`
                    : '',
                packs: parseInt(doc.package_load) || 0,
                unities: parseInt(doc.unit_load) || 0,
                desp: parseInt(doc.quantity_load) || 0,
                return:
                  stateDoc && stateHR ? (
                    <TextField
                      key={i}
                      fullWidth
                      value={doc.quantity_returned || ''}
                      onChange={(e) => changeValueDocDetail(doc.id, 'returns', e.target.value)}
                      inputProps={{
                        min: 0,
                        max: parseInt(doc.quantity_load),
                        style: { textAlign: 'center' }
                      }}
                      margin="normal"
                      size="small"
                      type="number"
                    />
                  ) : (
                    doc.quantity_returned
                  ),
                total: currency(doc.GTotal),
                diference: parseInt(doc.quantity_load - doc.quantity_returned),
                state:
                  stateDoc && stateHR ? (
                    <Select
                      fullWidth={true}
                      value={doc.liq_status || '0'}
                      onChange={(e) => changeValueDocDetail(doc.id, 'state', e.target.value)}
                    >
                      {listStatesDoc.map((bListDoc, i) => {
                        return (
                          <MenuItem key={bListDoc.id} value={bListDoc.id}>
                            {bListDoc.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : doc.liq_status == '' || doc.liq_status == null || doc.liq_status == '-1' ? (
                    '-'
                  ) : (
                    listStatesDoc[listStatesDoc.findIndex((obj) => obj.id == doc.liq_status)].name
                  ),
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {props.showEye === false ? (
          <Button
            color={props.themeContext.buttonColorSuccess}
            onClick={() => {
              if (stateHR)
                saveDocument(selectedDoc.id, listDocDetail, (state, data) => {
                  if (state) {
                    setShowErrorResp({ show: false });
                  } else {
                    setShowErrorResp({ data: data, show: true });
                  }
                }, responsible);
            }}
            disabled={listDocDetail.length > 0 && stateHR == true ? false : true}
          >
            <Save className={classes.icons} />
            Guardar
          </Button>
        ) : undefined}

        <Button color={props.themeContext.buttonColorDanger} onClick={handleClose}>
          Cancelar
        </Button>
      </div>
    </ModalFull>
  );
});

const HeaderModal = ({ selectedDoc, totals }) => {
  return (
    <div style={{ padding: 10, border: '1px solid #d2d2d2', borderRadius: 10 }}>
      <GridContainer>
        <GridItem xs={3} sm={2} md={2}>
          <b>ID DOC: </b> {selectedDoc.id || '-'}
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          <b>Documento: </b> {selectedDoc.document_sunat || '-'}
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          <b>Código: </b> {selectedDoc.CardCode || '-'}
        </GridItem>
        <GridItem xs={3} sm={4} md={4}>
          <b>Cliente:</b> {selectedDoc.CardName || '-'}
        </GridItem>
      </GridContainer>
      <hr />
      <GridContainer>
        <GridItem xs={3} sm={2} md={2}>
          <b>Completo:</b> {totals.completed}
        </GridItem>
        <GridItem xs={3} sm={2} md={2}>
          <b>Anulado:</b> {totals.anulated}
        </GridItem>
        <GridItem xs={3} sm={2} md={2}>
          <b>Parcial:</b> {totals.partial}
        </GridItem>
        <GridItem xs={3} sm={2} md={2}>
          <b>Total: {parseFloat(selectedDoc.total).toFixed(2) || '-'}</b>
        </GridItem>
      </GridContainer>
    </div>
  );
};

const ErrorResponse = ({ data }) => {
  const classes = useStyles();
  return (
    <table className={classes.table}>
      <thead>
        <tr>
          <th>Descripción</th>
          <th>Cantidad</th>
          <th>Promoción</th>
          <th>Regla</th>
          <th>Grupo</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={i}>
            <td>{item.ItemName}</td>
            <td align="center">{parseFloat(item.cannbondev)}</td>
            <td>
              {item.idprom} - {item.promotion_description}
            </td>
            <td align="center">
              {item.idregla} - {item.rule_description}
            </td>
            <td align="center">{item.idgrupo}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
